<template>
  <h1>進銷存記錄</h1>
</template>

<script>
export default {}
</script>

<style></style>
